import React from "react";
import { type AvatarSizes, UserAvatar } from "./Avatar";

interface Props {
  user: server.dto.UserSmall
  avatarSize?: AvatarSizes
  nameHref?: string
  style?: React.CSSProperties
}

const UserWithAvatar = ({ user, avatarSize, nameHref, children, style }: React.PropsWithChildren<Props>) => {
  return <div className="flex gap" style={style}>
    <div>
      <UserAvatar user={user} size={avatarSize} />
    </div>
    <div className="flex-column gap-small">
      <div>
        {!nameHref && user.fullName}
        {nameHref && <a href={nameHref}>{user.fullName}</a>}
      </div>
      {children}
    </div>
  </div>;
};

export default UserWithAvatar;